import { useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { Navigate } from "react-router-dom";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "@/configs/msal-config";
import { useLoading } from "@/context/LoadingContext";
import Copyright from "@/components/Copyright";
import { DefaultPrimaryButton } from "@/styles/globalstyles";

export default function LoginPage() {
  const { instance, inProgress } = useMsal();
  const { increaseLoading, decreaseLoading } = useLoading();
  const isAuthed = useIsAuthenticated();

  const handleSignIn = async () => {
    instance.loginRedirect(loginRequest);
  };

  const isInProgress = inProgress !== "none";

  useEffect(() => {
    if (!isInProgress) return;
    increaseLoading();
    return () => {    
      decreaseLoading()
    };
  }, [isInProgress, increaseLoading, decreaseLoading]);

  if (isAuthed) {
    return <Navigate to={"/"} replace />;
  }

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "80vh",
          justifyContent: "center",
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: "#03A0A8" }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography variant="h1" sx={{ mt: 3 }}>
          Siam Kubota
        </Typography>
        <Typography variant="h2" sx={{ mt: 1 }}>
          Login with azure AD
        </Typography>
        <Box sx={{ mt: 1 }}>
          <Button
            type="button"
            fullWidth
            variant="contained"
            onClick={async () => {
              handleSignIn();
            }}
            sx={{ mt: 3, mb: 2, ...DefaultPrimaryButton }}
          >
            Sign In
          </Button>
          <Copyright />
        </Box>
      </Box>
    </Container>
  );
}
